import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HotelService from "../../services/hotel.service";

/* =================== Thunks =================== */

export const getHotel = createAsyncThunk(
  "hotel/getHotel",
  async (params, thunkAPI) => {
    try {
      const response = await HotelService.getHotel(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const addHotel = createAsyncThunk(
  "hotel/addHotel",
  async (data, thunkAPI) => {
    try {
      const response = await HotelService.addHotel(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const updateHotel = createAsyncThunk(
  "hotel/updateHotel",
  async (payload, thunkAPI) => {
    try {
      const response = await HotelService.editHotel(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const deleteHotel = createAsyncThunk(
  "hotel/deleteHotel",
  async (id, thunkAPI) => {
    try {
      console.log("API response 1 in slice ");
      await HotelService.deleteHotel(id);
      console.log("API response 2 in slice");
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

/* =================== >>  State =================== */

const initialState = {
  loading: false,
  error: null,
  hotelLists: [],
  updateSuccess: false,
  fetched: false,
};

/* =================== Slice =================== */

const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getHotel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHotel.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelLists = action.payload?.data || [];
      })
      .addCase(getHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addHotel.fulfilled, (state, action) => {
        const newHotel = action.payload?.hotel || action.payload;

        if (
          newHotel &&
          !state.hotelLists.some((h) => h._id === newHotel._id)
        ) {
          state.hotelLists.unshift(newHotel);
        }
      })

      /* ---------- Update ---------- */
      .addCase(updateHotel.fulfilled, (state, action) => {
        state.updateSuccess = true;

        const updated = action.payload?.data || action.payload;

        if (updated?._id) {
          const index = state.hotelLists.findIndex(
            (h) => h._id === updated._id
          );
          if (index !== -1) {
            state.hotelLists[index] = updated;
          }
        }
      })

      /* ---------- Delete ---------- */
      .addCase(deleteHotel.fulfilled, (state, action) => {
        state.hotelLists = state.hotelLists.filter(
          (hotel) => hotel._id !== action.payload
        );
      }).addCase(deleteHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export const { resetUpdateStatus } = hotelSlice.actions;
export default hotelSlice.reducer;
